import { HolidayMap, WorkingHoursMap, TimePreset } from "../../types";

export const initialHolidays: HolidayMap = {
  '2025-04-11': { name: 'Labours day', type: 'company' },
  '2025-04-01': { name: 'New Year', type: 'federal' }
};

export const initialWorkingHours: WorkingHoursMap = {
  monday: { isWorking: true, startTime: '09:00', endTime: '17:00' },
  tuesday: { isWorking: true, startTime: '09:00', endTime: '17:00' },
  wednesday: { isWorking: true, startTime: '09:00', endTime: '17:00' },
  thursday: { isWorking: true, startTime: '09:00', endTime: '17:00' },
  friday: { isWorking: true, startTime: '09:00', endTime: '17:00' },
  saturday: { isWorking: true, startTime: '09:00', endTime: '17:00' },
  sunday: { isWorking: false, startTime: '09:00', endTime: '17:00' }
};

export const timePresets: TimePreset[] = [
  { label: '9AM - 5PM', start: '09:00', end: '17:00' },
  { label: '8AM - 4PM', start: '08:00', end: '16:00' },
  { label: '8AM - 6PM', start: '08:00', end: '18:00' },
  { label: '7AM - 3PM', start: '07:00', end: '15:00' }
];

export const commonSchedules = [
  '9AM - 5PM',
  '8AM - 4PM',
  '8AM - 6PM',
  '10AM - 6PM'
];

export const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

export const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'] as const;
export const weekends = ['saturday', 'sunday'] as const;